module.exports = __webpack_public_path__ + "pic/39.3d0e8eea.png";